/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
// Sage Routing using JS Module Pattern
var UTIL = (function () {
  // var currentBreakpoint = breakpoint();
  var $document = $(document);
  var initialPageLoad = true;
  var prevArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 238.2 474.1"><path d="M67.9 169.1c0.8 1-1.2-1.3 3-3 1.3-1.2 4-5.8 8.4-8.4 1.8-2.5 5.1-3.7 5.8-6.1 2.8-0.2 4.1-4.2 7-6.8 1.7-2.2 4.6-5.5 7.9-7.5 2.9-2.4 5.8-6 8.3-8.7 2.2-1.4 4.2-3.2 4.3-4.3 1.6-1.8 2.9-2.6 4.5-4.6 1.7-1.7 3.3-3.5 4.7-4.8 1.8-1.7 2.9-3 5-4.9 2-1.8 2.8-3.5 4.5-5.6 1.6-1.9 3.8-3.7 5.2-4.5 1.9-1.2 3.3-3.4 4.8-5.1 1.2-1.6 3.6-3.3 5.4-4.6 1.2-1 2.9-2.8 4.6-4.6 1.8-1.2 3.7-3.1 5.2-5.6 1.5-2.2 3-3.9 5.1-5.3 2.6-1.8 3.5-3.2 5.1-4.7 1-1.7 3.6-3.3 4.8-5.2 1-1.4 3-3.9 5.4-5.1 2.8-1.2 2.5-2.5 4.8-4.3 1.5-1.6 2.7-1.1 4.4-4.8 0.7-1.7 4.6-3.4 5.4-5.2 0.8-1.8 1.4-3 4.9-5.2 1.3-1.3 4.8-2.4 5.1-4.8 2.2-0.9 3.3-2.6 4.5-4.8 2.1-5.5 7.8-3.8 8.8-8.7 2.3-2 5.4-4.8 7.3-7.4 2.8-1.6 5.2-4.1 6.3-6.3 1.2-1.4 4.3-3.4 4.5-4.5 2.1-2.8 3.2-3 3.9-3.9 -0.4 1.8 0.2 5 0 10.1 1.1 2.4 0 6.3 0.4 10.8 -1.1 2.2-0.3 6.5-0.1 7 1.5 3.4-1.2 5-0.2 7.3 -0.1 1.6 0.3 6.6 0.1 7.9 -0.7 3.5 0 5.3 0 8 -0.2 4-0.6 7 0.3 8.8 1.5 5-0.1 5.5-0.3 8 0.7 1.4 0.4 4.6 0.6 8.7 0.3 2.4-0.6 5.7-0.6 8.1 0.1 0.1-0.6 4.5-0.3 8.1 1.7 2.3 1.8 3 0.3 7.7 -0.1 2.3-0.3 5.1-0.5 7.3 -0.3 2.8-0.2 5.3 0.6 6.6 -1.2 5.3-0.2 7.2-0.1 11.2 -0.3 7.4-1.3 9.9 0 10.1 -0.2-1-1.8 1.2-5.6 5.6 -0.9 3.3-3.5 4.3-6.4 6.6 -2.2 0.6-5.1 7.3-8 7.8 -2.4 1.2-3.2 3.9-4.8 4.6 -4.6 1-1.9 1.5-4.7 4.8 -1.5 2.3-3.2 4.8-5.1 5.1 -1.3 0.9-4.7 3.3-5.2 5.2 -2.1 0.7-4.3 3.6-6.3 6.3 -2.4 2.4-3.8 4.9-4.6 4.6 -3.2 2.5-4.5 4.1-5.3 5.9 -0.9 1.6-2 3-5.3 4.7 0.4-1.2-2.5 2.5-5.4 4.7 -2.7 2.1-3.5 0-5 4.9 -1.6 4.2-3.5 1.6-4.7 5.1 0 3.9-4.1 2.4-4.7 5.1 -1.8 1.5-3.5 6.2-8.3 8.2 0 1.7-5 7.1-6.1 6.3 -3.7 5.6-2.6 7.9-5.6 5.6 -2.3 2 1.6 3.2 5.6 5.6 2.4 2.3 2.7 4.7 6.3 6.2 4.7 3.4 8.2 4.2 8.1 8.3 3.4 0.5 4 1 4.6 4.6 3.4 0.2 2 6.8 4.6 4.4 -0.8-1.8 1 2.5 5.4 5.4 1.9 3.2 5.9 4.1 5 5.4 1.4-1 6.6 6.6 5.7 5.4 3.3-0.1 4 4.2 5.3 5.4 0.7 3.6 3.2 6.8 5.4 5.4 1.3 1.1 4.9 2.4 5.2 5.3 0.4 2.7 3.9 3.4 5.1 4.9 2.1 2.1 2.6 4.7 5.2 5.5 0.5 3.5 2.9 2.8 5.6 4.9 1.8 0.5 2.5 4.4 3.9 4.5 3.5 4.2 4.6 8.9 7.8 7.7 1.3 0.3 5.5 5.6 6.6 6.8 5.7 8.6 8.6 9.9 5.6 5.6 2.1 1.9-0.7 7.5 0 10.1 -4.1 5.9-1.7 13.4-0.9 11 -0.1 3.6 0.1 5.6-0.5 8.5 -1.4 3.4 0.6 4.2 1.4 5.6 -0.4 1.9-0.7 2.7-0.9 6.3 0.1 2.7 0.5 5.4 0.6 9.7 1.4 2.5 0.9 5.4 1 8.1 -0.1 1.5-1.1 6.4-0.7 8.5 1.2 2.5 0.9 6.1 1.2 9 -1.1 2.7 0.6 5-0.8 7.8 0.1 2.5-0.5 4.6-1.1 7.4 -0.2 3.3 0.5 5.8 0.6 8.6 0.3 3.1 0.3 5.5 0.3 7.6s-0.1 4.1 0.2 6.2c0.6 3.3 0.4 7.6-0.5 11.3 0 6.3 0 11 0 10.1 -0.4 0.1-0.1-0.3-3.1-3.1 -3.8-0.9-5.4-4.1-8.7-8.7 -2.1-3-3.6-3.6-6.1-6 -2.4-1.9-5.5-4.6-7.1-7.2 -2.9-1-4.1-4.5-8-7 -2.6-2.3-5.4-5.8-8.6-9.6 -1.5-1.1-3.1-2.5-4.6-4 -1.6-1.6-3.1-3.3-4.6-5.3 -1.4-1.1-3.2-2.7-4.7-4.4 -2.4-2.1-3.9-3.5-4.9-5.2 -2.5-2.6-3.5-3.1-5.1-5.1 -1.7-1.3-2.9-3.2-4.9-5 -0.6-1-2.3-3.5-4.8-4.2 -2.1-1.1-4.3-3.5-5.4-5.9 -2.2 0.1-1.6-2.6-5.1-5.2 -1.4-1.4-4.4-3.3-5.1-5.2 -2.4-0.9-2.6-4.8-5-5 -1-3.3-1.9-5.6-5.2-5.1 -3.5-1.2-4-0.8-4.8-4.4 -2.5-4.6-2.7-4.5-4.9-5.4 -3.1-2.3-3.3-2.7-5-4.7 -2-0.3-2.1-2.2-4.8-5.1 -0.7-2.1-2.2-3.3-4.5-4.5 -2.3-3.1-4.9-3.7-4.9-5 -4-2-6.4-4.7-8.2-8.1 -3.3-4.2-5.5-7.1-8.6-8.6 -4.2-1.7-4.8-4.4-7.5-7.5 -3.3-2.4-3.8-3.6-6-6.3 -1.3-4-4.1-3.8-4.8-4.5 -1.8-2.6-3.4-1.1-3.9-3.9 -0.5 0.6-1.1-3.8-7.1-7.1 -2.7-0.7-5.8-3.8-7.6-7.5 -0.8-1.9-2.1-1.6-4.4-4.3 -0.3 0-2.2-1.9-4.8-5 -0.8-1.7-3.4-5.1-4.9-4.6 -1.2-2.2-1.3-3.4-5-5.2 -4-2.8-1.5-4.4-5-5.2 -0.7-0.5-3.2-3.8-5.3-5.2 -2.1-2.2-4.5-2.7-4.9-4.2 0-1.6-4.6-3.9-4.3-5 -4.1-2.8-3-4.1-7.6-7.6C2.2 237.7 3 236.4 0 237c0.7-2.7 4.5-1.9 7.1-7.1 2.9-0.9 6.8-2.8 7.3-8 2.3-1.9 7-7.9 9.5-8.9 2.5-2.4 6.6-6.5 9.8-10.2 2.8-4.5 7.7-5.8 10.3-9.9 3.8-3.1 7.7-7.3 9.5-9 0.4-2 5.1-6.5 7.3-7.8C65.7 171.8 67.2 169.2 67.9 169.1z"/></svg>';
  var nextArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 238.2 474.1"><path d="M170.3 169.1c-0.8 1 1.2-1.3-3-3 -1.3-1.2-4-5.8-8.4-8.4 -1.8-2.5-5.1-3.7-5.8-6.1 -2.8-0.2-4.1-4.2-7-6.8 -1.7-2.2-4.6-5.5-7.9-7.5 -2.9-2.4-5.8-6-8.3-8.7 -2.2-1.4-4.2-3.2-4.3-4.3 -1.6-1.8-2.9-2.6-4.5-4.6 -1.7-1.7-3.3-3.5-4.7-4.8 -1.8-1.7-2.9-3-5-4.9 -2-1.8-2.8-3.5-4.5-5.6 -1.6-1.9-3.8-3.7-5.2-4.5 -1.9-1.2-3.3-3.4-4.8-5.1 -1.2-1.6-3.6-3.3-5.4-4.6 -1.2-1-2.9-2.8-4.6-4.6 -1.8-1.2-3.7-3.1-5.2-5.6 -1.5-2.2-3-3.9-5.1-5.3C74 73 73 71.7 71.4 70.2c-1-1.7-3.6-3.3-4.8-5.2 -1-1.4-3-3.9-5.4-5.1 -2.8-1.2-2.5-2.5-4.8-4.3 -1.5-1.6-2.7-1.1-4.4-4.8 -0.7-1.7-4.6-3.4-5.4-5.2 -0.8-1.8-1.4-3-4.9-5.2 -1.3-1.3-4.8-2.4-5.1-4.8 -2.2-0.9-3.3-2.6-4.5-4.8 -2.1-5.5-7.8-3.8-8.8-8.7 -2.3-2-5.4-4.8-7.3-7.4 -2.8-1.6-5.2-4.1-6.3-6.3C8.5 7 5.4 5 5.2 3.9 3 1.1 2 0.9 1.2 0c0.4 1.8-0.2 5 0 10.1 -1.1 2.4 0 6.3-0.4 10.8 1.1 2.2 0.3 6.5 0.1 7 -1.5 3.4 1.2 5 0.2 7.3 0.1 1.6-0.3 6.6-0.1 7.9 0.7 3.5 0 5.3 0 8 0.2 4 0.6 7-0.3 8.8 -1.5 5 0.1 5.5 0.3 8 -0.7 1.4-0.4 4.6-0.6 8.7 -0.3 2.4 0.6 5.7 0.6 8.1 -0.1 0.1 0.6 4.5 0.3 8.1 -1.7 2.3-1.8 3-0.3 7.7 0.1 2.3 0.3 5.1 0.5 7.3 0.3 2.8 0.2 5.3-0.6 6.6 1.2 5.3 0.2 7.2 0.1 11.2 0.3 7.4 1.3 9.9 0 10.1 0.2-1 1.8 1.2 5.6 5.6 0.9 3.3 3.5 4.3 6.4 6.6 2.2 0.6 5.1 7.3 8 7.8 2.4 1.2 3.2 3.9 4.8 4.6 4.6 1 1.9 1.5 4.7 4.8 1.5 2.3 3.2 4.8 5.1 5.1 1.3 0.9 4.7 3.3 5.2 5.2 2.1 0.7 4.3 3.6 6.3 6.3 2.4 2.4 3.8 4.9 4.6 4.6 3.2 2.5 4.5 4.1 5.3 5.9 0.9 1.6 2 3 5.3 4.7 -0.4-1.2 2.5 2.5 5.4 4.7 2.7 2.1 3.5 0 5 4.9 1.6 4.2 3.5 1.6 4.7 5.1 0 3.9 4.1 2.4 4.7 5.1 1.8 1.5 3.5 6.2 8.3 8.2 0 1.7 5 7.1 6.1 6.3 3.7 5.6 2.6 7.9 5.6 5.6 2.3 2-1.6 3.2-5.6 5.6 -2.4 2.3-2.7 4.7-6.3 6.2 -4.7 3.4-8.2 4.2-8.1 8.3 -3.4 0.5-4 1-4.6 4.6 -3.4 0.2-2 6.8-4.6 4.4 0.8-1.8-1 2.5-5.4 5.4 -1.9 3.2-5.9 4.1-5 5.4 -1.4-1-6.6 6.6-5.7 5.4 -3.3-0.1-4 4.2-5.3 5.4 -0.7 3.6-3.2 6.8-5.4 5.4 -1.3 1.1-4.9 2.4-5.2 5.3 -0.4 2.7-3.9 3.4-5.1 4.9 -2.1 2.1-2.6 4.7-5.2 5.5 -0.5 3.5-2.9 2.8-5.6 4.9 -1.8 0.5-2.5 4.4-3.9 4.5 -3.5 4.2-4.6 8.9-7.8 7.7 -1.3 0.3-5.5 5.6-6.6 6.8 -5.7 8.6-8.6 9.9-5.6 5.6 -2.1 1.9 0.7 7.5 0 10.1 4.1 5.9 1.7 13.4 0.9 11 0.1 3.6-0.1 5.6 0.5 8.5 1.4 3.4-0.6 4.2-1.4 5.6 0.4 1.9 0.7 2.7 0.9 6.3 -0.1 2.7-0.5 5.4-0.6 9.7 -1.4 2.5-0.9 5.4-1 8.1 0.1 1.5 1.1 6.4 0.7 8.5 -1.2 2.5-0.9 6.1-1.2 9 1.1 2.7-0.6 5 0.8 7.8 -0.1 2.5 0.5 4.6 1.1 7.4 0.2 3.3-0.5 5.8-0.6 8.6 -0.3 3.1-0.3 5.5-0.3 7.6s0.1 4.1-0.2 6.2c-0.6 3.3-0.4 7.6 0.5 11.3 0 6.3 0 11 0 10.1 0.4 0.1 0.1-0.3 3.1-3.1 3.8-0.9 5.4-4.1 8.7-8.7 2.1-3 3.6-3.6 6.1-6 2.4-1.9 5.5-4.6 7.1-7.2 2.9-1 4.1-4.5 8-7 2.6-2.3 5.4-5.8 8.6-9.6 1.5-1.1 3.1-2.5 4.6-4 1.6-1.6 3.1-3.3 4.6-5.3 1.4-1.1 3.2-2.7 4.7-4.4 2.4-2.1 3.9-3.5 4.9-5.2 2.5-2.6 3.5-3.1 5.1-5.1 1.7-1.3 2.9-3.2 4.9-5 0.6-1 2.3-3.5 4.8-4.2 2.1-1.1 4.3-3.5 5.4-5.9 2.2 0.1 1.6-2.6 5.1-5.2 1.4-1.4 4.4-3.3 5.1-5.2 2.4-0.9 2.6-4.8 5-5 1-3.3 1.9-5.6 5.2-5.1 3.5-1.2 4-0.8 4.8-4.4 2.5-4.6 2.7-4.5 4.9-5.4 3.1-2.3 3.3-2.7 5-4.7 2-0.3 2.1-2.2 4.8-5.1 0.7-2.1 2.2-3.3 4.5-4.5 2.3-3.1 4.9-3.7 4.9-5 4-2 6.4-4.7 8.2-8.1 3.3-4.2 5.5-7.1 8.6-8.6 4.2-1.7 4.8-4.4 7.5-7.5 3.3-2.4 3.8-3.6 6-6.3 1.3-4 4.1-3.8 4.8-4.5 1.8-2.6 3.4-1.1 3.9-3.9 0.5 0.6 1.1-3.8 7.1-7.1 2.7-0.7 5.8-3.8 7.6-7.5 0.8-1.9 2.1-1.6 4.4-4.3 0.3 0 2.2-1.9 4.8-5 0.8-1.7 3.4-5.1 4.9-4.6 1.2-2.2 1.3-3.4 5-5.2 4-2.8 1.5-4.4 5-5.2 0.7-0.5 3.2-3.8 5.3-5.2 2.1-2.2 4.5-2.7 4.9-4.2 0-1.6 4.6-3.9 4.3-5 4.1-2.8 3-4.1 7.6-7.6 4.9-6.3 4.1-7.6 7.1-7.1 -0.7-2.7-4.5-1.9-7.1-7.1 -2.9-0.9-6.8-2.8-7.3-8 -2.3-1.9-7-7.9-9.5-8.9 -2.5-2.4-6.6-6.5-9.8-10.2 -2.8-4.5-7.7-5.8-10.3-9.9 -3.8-3.1-7.7-7.3-9.5-9 -0.4-2-5.1-6.5-7.3-7.8C172.5 171.8 171 169.2 170.3 169.1z"/></svg>';
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
        // console.log( 'common:init js fired' );

        //Start preloader
        monkey.init();

        //load fonts
        WebFont.load({
          classes: false,
          google: {
            families: ['Barlow Semi Condensed:400,600,700', 'Oswald:400,500,700']
          }
        });

        // viewportUnitsBuggyfill is used to convert vh units on iOS and Android to px, this is so backgrond images and height based positioning does't change when scrolling and the viewport height increases. https://github.com/rodneyrehm/viewport-units-buggyfill
        if (['Android', 'iOS'].indexOf(mobileOS()) >= 0) {
          window.viewportUnitsBuggyfill.init({
            refreshDebounceWait: 250
          });
        }

        if (navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie === 1)) {
          $('#monkey-preloader').css('height', '300px');
        }

        $document.on('gform_post_render', function (event, form_id, current_page) {
          // alert('sdf')
          // code to trigger on form or form page render

        });

        //Initialse event handlers
        $document.bind('gform_post_render', function () {
          // alert('sss')
          custom_datepicker();
          select_box();
          bookTableOffset();
          file_upload();
          wrapWords();
          populateTimes();

          if (typeof gformInitDatepicker !== 'undefined') {
            gformInitDatepicker(); // Initialize all datepicker fields
          }
          //console.log( 'gform_post_render fired' );
        });

        $document.bind('gform_confirmation_loaded', appendWaves);

        $document.bind('gform_confirmation_loaded', function () {
          var $ga_event = $('.ga-event');
          var value = '';
          $('.offers-subtitle').css("display", "none");
          if ($ga_event.data('title') === 'Book a Table' && typeof $ga_event.data('value') === 'string') {
            value = Number($ga_event.data('value').replace('+', ''));
          } else {
            value = $ga_event.data('value');
          }
          // __gaTracker('send', 'event', $ga_event.data('title'), 'gform_confirmation_loaded', $ga_event.data('label'), value);
          dataLayer.push({ 'event': $ga_event.data('title'), 'gform_confirmation_loaded': $ga_event.data('label') })
          ////
          fbq('track', 'CompleteRegistration');
          console.log("tried to register");
          ////

        });

        $document.bind('gform_page_loaded', appendWaves);

        $document.on('change', '.locations select', function () {
          custom_datepicker();
        });

        $document.on('change', '.locations select, .date input', function () {
          populateTimes();
        });

        $('.hamburger')
          .on('click', function () {
            $(this)
              .toggleClass('is-active');
            $('body')
              .toggleClass('menu-open');
          });

        if (getIEVersion() > 0) {
          console.log('IE detected');
        }
        else {
          $document.on('submit', '.gform_wrapper form', function (event) {

            ////
            // fbq('track', 'CompleteRegistration');
            // console.log("tried to register");
            ////

            var target = '#' + event.target.target;
            // event.preventDefault();
            //
            // $.post(target, $(event.target).serialize(), function (data) {
            //   var $target = $(target);
            //   $target.contents().find('html').html(data);
            //   $target.trigger('load');
            //   // $target.attr( 'src', $target.attr('src') + '?v=' + Math.random() ) ;
            // });
          });
        }

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        // console.log( 'common:finalize js fired' );

        Pace.on('hide', function () {

          custom_datepicker();
          select_box();
          bookTableOffset();
          file_upload();
          wrapWords();
          populateTimes();
          appendWaves();
          monkeyPadding();
          loadOpenTableScripts();
          eventToOpenMainBookingScript();

          if (typeof gformInitDatepicker !== 'undefined') {
            gformInitDatepicker(); // Initialize all datepicker fields
          }

          if (!$('body').hasClass('faqs') && !$('body').hasClass('the-rodizio-experience')) {
            waves();
          }

          if ($('#header-slider')) {
            var tl = new TimelineMax();
            var headerImage = $('#header-slider .featured-image');

            $('#header-slider')
              .on('init', function (event, slick) {
                headerContentScroll();
              })
              .slick({
                appendArrows: '#header-inner',
                arrows: true,
                dots: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 1500,
                pauseOnHover: false,
                pauseOnFocus: false,
                infinite: true,
                speed: 900,
                cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
                touchThreshold: 100,
                prevArrow: '<button type="button" class="slick-prev svg header-content-scroll">' + prevArrow + '</button>',
                nextArrow: '<button type="button" class="slick-next svg header-content-scroll">' + nextArrow + '</button>',
                responsive: [
                  {
                    breakpoint: 800,
                    settings: {
                      arrows: false,
                      appendDots: '#page-header',
                    }
                  }
                ]
              });
          }

          if (breakpoint() === 'desktop') {
            // Boh shadow parallax animation
            shadowParallax();
          }


          /*
          * -- 
          */

          // Start - Dynamically load airship scrip on page change
          const $scriptContainer = $('.airship-script');
          if ($scriptContainer.length) {
            const scriptEl = $scriptContainer.prev().get('0')

            var script = document.createElement("script");
            script.src = scriptEl.getAttribute("src");

            // Define a callback function to execute after the script is loaded
            script.onload = function () {
              console.log("Script loaded and executed!");
            };

            var container = document.querySelector(".airship-script");
            container.appendChild(script);
          }
          // End - Dynamically load airship scrip on page change

          if (!$('body').hasClass('menu-open')) {
            TweenMax.to('.pace, #preloader', 0.3, {
              autoAlpha: 0,
              onComplete: function () {
                monkey.pause();
                if (breakpoint() === 'desktop') {
                  contentReveal();
                  if (initialPageLoad) {
                    navAnimation();
                    initialPageLoad = false;
                  }
                }
                foodSliderDots();
                $(window).resize(function () {
                  $('.fade-in, .fade-in-first, .site-logo, .hamburger, .menu, .social-links').css('opacity', 1);
                  $('.fade-in, .fade-in-first, .site-logo, .hamburger, .menu, .social-links').css('visibility', 'visible');
                  $('#site-header').css('background-color', '#ffffff');
                });
              }
            });
          } else {
            $('.hamburger')
              .removeClass('is-active');
            $('body')
              .removeClass('menu-open');
          }

          // $('.selectboxit-option-first').addClass('dropdown-disabled');
          $('#book-a-table .selectboxit-option-first').addClass('selectboxit-disabled');
          $('#book-a-table .selectboxit-option-first').data('disabled', 'true');

          //console.log( 'PACE: Page loaded' );
        });
        // Menu toggle
        $(window)
          .resize(function () {
            // console.log( breakpoint() );
          });

        // $('body').on('submit', '#gform_1', function(e) {
        //   e.preventDefault();
        //   console.log('not submitted');
        // });
      }
    },
    'home': {
      init: function () {

      },
      finalize: function () {
      }
    },
    'careers': {
      init: function () {

      }
    },
    'news_and_offers': {
      init: function () {
        $(window).on('load', function () {
          var $grid = $('.articles-grid').masonry({
            itemSelector: '.grid-item',
            columnWidth: 315,
            gutter: 10,
            isFitWidth: true
          });
        });
        var $grid = $('.articles-grid').masonry({
          itemSelector: '.grid-item',
          columnWidth: 315,
          gutter: 10,
          isFitWidth: true
        });
      },
    },
    'single_offer': {
      init: function () {

        // Term and conditions modal:
        tcModal();
        $document.bind('gform_page_loaded', tcModal);

        //Adding class to bofy after gform is submitted:
        var codeElementHeight = $('#offer-code').outerHeight(true);

        jQuery(document).bind('gform_confirmation_loaded', function (event, formId) {
          $('body').addClass('gform-submitted');
          $('#offers-form').css('margin-bottom', codeElementHeight);
          fbq('track', 'CompleteRegistration');
          console.log("tried to register");
        });

        $("#offers-form select").on('change', function () {
          $('.form-wrapper').css('display', 'none');
          $('.form-wrapper.' + this.value).css('display', 'block');
        })
      },
    },
    'download_app': {
      init: function () {
        appHeaderOffset();

      }
    },
    'faqs': {
      init: function () {
        $('body')
          .on('click', '#faq-list button', accordionToggle);
      }
    },
    'locations': {
      init: function () {
        initMaps();

        $('#location-list')
          .on('click', 'button', function () {
            $(this)
              .parents('article')
              .find('.acf-map')
              .toggleClass('visible');
          });
      }
    },
    'post_type_archive_offer': {
      init: function () {

        var div = $('.selectboxit-option-first');
        // console.log(div.style('display'));

        div.css('background-color', 'red');

        if (window.location.href.indexOf('location') > -1) {
          $('body').addClass('offers-filtered');
          var location = window.location.href.split('=')[1];

          $('#offer-list li').each(function (i) {
            var id = $(this).attr('id').split('-');
            id.shift();
            var offerSlug = id.join('-');
            $(this).children('a').attr('href', '/offers/' + offerSlug + '?location=' + location);
          });
        }

        var $offers = $('#offer-list li');
        $document.on('change', '#offer-filter select', function () {
          TweenLite.to('#offer-list-wrapper', 1, {
            display: 'block',
            opacity: 1
          });
          updateOffers(this, $offers);
        });
      }
    },
    'our_food': {
      init: function () {

        if ($('#menu ul')) {
          $('#menu ul')
            .on('init', function (event, slick) {

              var foodSliderMeats = '.slick-active dl > div';
              var tween = TweenMax.staggerFromTo($(foodSliderMeats), 0.3, {
                y: '-10px',
                autoAlpha: 0
              }, {
                y: 'auto',
                autoAlpha: 1
              }, 0.15);
            })
            .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              var foodSliderMeats = $('.slick-active dl > div');
              TweenMax.staggerTo(foodSliderMeats, 0.3, {
                autoAlpha: 0,
                ease: Back.easeOut.config(1)
              }, 0.1);
            })
            .on('afterChange', function (slick, currentSlide) {
              var foodSliderMeats = $('.slick-active dl > div');
              TweenMax.staggerFromTo(foodSliderMeats, 0.3, {
                autoAlpha: 0,
                y: '-=10px'
              }, {
                autoAlpha: 1,
                y: 'auto',
                ease: Back.easeOut.config(1)
              }, 0.1);
            })
            .slick({
              adaptiveHeight: true,
              appendDots: '#menu .container',
              arrows: false,
              dots: true,
              fade: true,
              infinite: true,
              speed: 900,
              cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
              touchThreshold: 100,
              customPaging: function (slider, i) {
                return $('<button type="button" />')
                  .text($(slider.$slides[i])
                    .data('title'));
              }
            });
          menuDotsOffset(breakpoint());
          $(window)
            .resize(function () {
              menuDotsOffset(breakpoint());
            });
        }
      }
    },
    'book_a_table':
    {
      init: function () {
      }
    },
    'single_restaurant':
    {
      init: function () {
        initMaps();
        scrollDown('#restaurant-book-table', '#book-a-table');
        var instaFeed = new Instafeed({
          accessToken: '565957218.1677ed0.292782a42c5c442ba7f9c435ccfdcb59',
          clientId: 'e367405de48040bebc40c7db2be680e1',
          get: 'user',
          userId: '565957218',
          limit: 5,
          sortBy: 'random',
          imageResolution: 'standard-resolution',
          template: '<a class="insta-images" href="{{link}}" rel="noopener noreferrer" target="_blank"><img src="{{image}}" /></a>'
        });
        instaFeed.run();
      }
    },
    'the_rodizio_experience':
    {
      init: function () {
        rodizioExperience.init();

        if ($('#experience-slider ul')) {
          $('#experience-slider ul')
            .slick({
              arrows: true,
              speed: 500,
              fade: true,
              autoplay: true,
              autoplaySpeed: 2000,
              // dots: true,
              prevArrow: '<button type="button" class="slick-prev svg">' + prevArrow + '</button>',
              nextArrow: '<button type="button" class="slick-next svg">' + nextArrow + '</button>'
            });
        }
      }
    }
  };
  var fire = function (func, funcname, args) {
    var fire;
    var namespace = Sage;
    funcname = (funcname === undefined) ?
      'init' :
      funcname;
    fire = func !== '';
    fire = fire && namespace[func];
    fire = fire && typeof namespace[func][funcname] === 'function';
    if (fire) {
      namespace[func][funcname](args);
    }
  };
  var loadPage = function () {
    $.each(document.body.className.replace(/-/g, '_')
      .split(/\s+/),
      function (i, classnm) {
        fire(classnm);
        fire(classnm, 'finalize');
      });
  };
  var loadEvents = function () {
    fire('common');
    loadPage();
    fire('common', 'finalize');
  };
  // Load Events
  $(document)
    .ready(loadEvents);
  return {
    fire: fire,
    loadPage: loadPage,
    loadEvents: loadEvents
  };
})
  ();
